import { pageHead } from "@/lib/route-head";
import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";

export const Route = createFileRoute("/")({
  head: () => pageHead({ path: "/", title: "Amorette — Elegant Connections, Curated Dinners", description: "Amorette connects people through elegant, curated dinner experiences. Discover meaningful connections over exceptional dining." }),
  component: Index,
});
